<div class="new-dashboard-page min-full-height-content page-container container-fluid">
    <div class="row">
        <div class="dashboard-card-container col-12 col-xl-6" *claim="claim.ViewRequestFunds">
            <request-funds [accountSnapshotDataSource]="accountSnapshotDataSource"></request-funds>
        </div>
        <div class="dashboard-card-container col-12 col-xl-6" *claim="claim.ViewRequestFunds">
            <fund-requests></fund-requests>
        </div>
        <div
            class="dashboard-card-container col-12 col-xl-9"
            *ngIf="isValidClientForInsightReports && (creditReportFeatureFlag$ | async)"
        >
            <summary [accountSnapshotDataSource]="accountSnapshotDataSource"></summary>
        </div>
        <div
            class="dashboard-card-container col-12"
            *ngIf="!isValidClientForInsightReports || !(creditReportFeatureFlag$ | async)"
        >
            <summary [accountSnapshotDataSource]="accountSnapshotDataSource"></summary>
        </div>
        <div
            class="dashboard-card-container col-12 col-xl-3"
            *ngIf="isValidClientForInsightReports && (creditReportFeatureFlag$ | async)"
        >
            <portfolio-report-card
                [canDownloadInsightsReportDataSource]="canDownloadInsightsReportDataSource"
            ></portfolio-report-card>
        </div>
        <div class="dashboard-card-container col-12 col-xl-6">
            <aging-summary [agingOverviewDataSource]="agingOverviewDataSource"></aging-summary>
        </div>
        <div class="dashboard-card-container col-12 col-xl-6" *claim="claim.ViewReports">
            <collections></collections>
        </div>
    </div>
</div>
